module.exports = "./img/8524b08652fa5cca44e69a65b42d566c.png";